// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comment-wrapper {
  display: flex;
  position: absolute;
  top: 15%;
  min-width: 30%;
  max-width: 50%;
}

.comment-wrapper.comment-on-right {
  right: unset !important;
  margin-right: unset !important;
  margin-left: var(--spacing-small);
}

.comment-wrapper.comment-on-left {
  left: unset !important;
  margin-right: calc(6px + var(--spacing-small)) !important;
  margin-left: unset !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/patient/components/raw-pressure-graph/raw-pressure-graph.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,cAAA;EACA,cAAA;AACF;;AAEA;EACE,uBAAA;EACA,8BAAA;EACA,iCAAA;AACF;;AAEA;EACE,sBAAA;EACA,yDAAA;EACA,6BAAA;AACF","sourcesContent":[".comment-wrapper {\n  display: flex;\n  position: absolute;\n  top: 15%;\n  min-width: 30%;\n  max-width: 50%;\n}\n\n.comment-wrapper.comment-on-right {\n  right: unset !important;\n  margin-right: unset !important;\n  margin-left: var(--spacing-small);\n}\n\n.comment-wrapper.comment-on-left {\n  left: unset !important;\n  margin-right: calc(6px + var(--spacing-small)) !important;\n  margin-left: unset !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
